// extracted by mini-css-extract-plugin
module.exports = {"vervBar":"vervBar_vervBar__VJTa6"};